<template>
  <div>
   <!-- <div class="isnstoreback" @click="goisnstore(isnstoreregistrationtype)" v-if="isnstoreregistration">{{isnstoreregistrationtype==1?'回到商店选择':'返回'}}</div> -->
   <div :class="['main',currentPath=='th20'?'th20':'']" id="header-main" v-show="isShow">
     <div
       class="header-container"
       ref="header_container_ref"
       id="header-container"
     >
       <div class="refound" v-if="showRefound" @click="rules = true">
         {{ deliveryRule.name }}
       </div>
       <header
         :class="[
           'header header_pc',
           showRefound ? 'show-refound-content' : '',
           searchModeal ? 'search' : '',
           showRefound && searchModeal ? 'maxsearch' : '',
         ]"
       >
         <div class="left_content">
           <ul
             
             v-for="(headerItem, index) in allMenuList"
             :key="index"
             @mouseleave="mouseLeaveMenu('1')"
           >
             <li
               @click="getDetailMenu(index)"
               ref="mainmenu"
               @mouseover="mouseOverMenu(index,1)"
               v-if="
                 ($store.state.userLogin &&
                   headerItem.thisOne.showType == 'member') ||
                 headerItem.thisOne.showType == 'all'
               "
             >
               <span
                 :class="[
                   firstHoverName == headerItem.thisOne.name
                     ? 'line'
                     : 'default',
                 ]"
                 ><a :target="headerItem.thisOne.newWindows?'_blank':'_self'" :href="headerItem.thisOne.linkUrl?hrefhost+headerItem.thisOne.linkUrl:'javascript:void(0);'">{{ headerItem.thisOne.name }}</a></span
               >
             </li>
           </ul>
         </div>
         <div class="center_content">
          <a target="_self" :href="hrefhost+'/'"><img class="logo" src="../../assets/image/logo/logo.svg" /></a> 
         </div>
         <div class="right_content">
           <div :class="['right_item search-item']" @click="searchProduct">
             <!-- <Icon type="ios-search" style="font-size:1.5rem;font-weight: bold;" /> -->
 
             <img
               :class="['search-icon', searchModeal ? 'active-search' : '']"
               src="../../assets/image/icon/search.png"
             />
           </div>
           <div class="right_item"><a target="_self" :href="hrefhost+'/stores'">店铺</a></div>
           <!-- <div class="right_item">配送到CN|$</div> -->
           <div class="right_item" v-if="hasLogin">
             <a target="_self" :href="hrefhost+'/login'">登录</a>  
           </div>
           <div style="position: relative" v-else>
             <div
               class="right_item min-shop-bag"
               :class="[showMyAccount ? 'active-bag' : '']"
               @mouseover="onMouseOvershowMyAccount()"
               @mouseleave="onMouseLeaveshowMyAccount()"
             >
               <span><a target="_self" :href="hrefhost+'/account/user-info'">我的账户</a></span>
             </div>
             <div
               @mouseover="onMouseOvershowMyAccount()"
               @mouseleave="onMouseLeaveshowMyAccount()"
             >
               <account
                 :showMyAccount="showMyAccount"
                 :accountType="1"
                 :hoverMenu="hoverMenu"
                 v-on:exit="userExit"
               ></account>
             </div>
           </div>
           <div
             style="position: relative"
             @mouseover="onMouseOvershowLoveList()"
             @mouseleave="onMouseLeaveshowLoveList()"
           >
             <div
               class="right_item min-shop-bag"
               :class="[showLoveList ? 'active-bag' : '']"
             >
               <span @click="goRouter('/account/love-list')"
                 ><a target="_self" :href="hrefhost+'/account/user-info'">心愿单 </a>{{ lovecount && !hasLogin ? lovecount : "" }}</span
               >
             </div>
             <div>
               <min-love-list
                 :showLoveList="showLoveList"
                 @makeLoveListShow="makeLoveListShow"
               ></min-love-list>
             </div>
           </div>
           <div
             style="position: relative"
             @mouseover="onMouseOvershowShopCart()"
             @mouseleave="onMouseLeaveshowShopCart()"
           >
             <div
               class="right_item min-shop-bag"
               :class="[showMyShopCart ? 'active-bag' : '']"
             >
               <span @click="goRouter('/shop-cart')"
                 >购物袋 {{ cartcount && !hasLogin ? cartcount : "" }}</span
               >
             </div>
             <div>
               <min-shop-bag
                 @showAddMember="showAddMember"
                 @getCartCount="getCartCount"
                 @makeShopShow="makeShopShow"
                 :showMyShopCart="showMyShopCart"
               ></min-shop-bag>
             </div>
           </div>
         </div>
       </header>
     </div>
 
     <div
       :class="[showMenuList ? 'showMenu' : 'hideMenu', ' header_menu_pc']"
       @mouseleave="mouseLeaveMenu()"
       @mouseover="mouseOverMenu(showMenuType)"
     >
       <div class="menus">
         <ul :class="[menu.thisOne.name=='世界'?'word':'','menus_item'] " v-for="(menu, index) in menuList" :key="index">
           <li  :class="['mainLi',index2>0?'mainLi2':''] " v-for="(menu2, index2) in menu.nextList" :key="index2">
             <ul
               class="menu_dd"
               v-if="
                 ($store.state.userLogin &&
                   menu2.thisOne.showType == 'member') ||
                 menu2.thisOne.showType == 'all'
               "
             >
               <div class="menu_name">
                 <li class="menu_cc">
                   <span @click="goPage(menu2.thisOne)">
                    
                    <a :target="menu2.thisOne.newWindows?'_blank':'_self'" :href="menu2.thisOne.linkUrl?(hrefhost+menu2.thisOne.linkUrl):'javascript:void(0);'"> {{ menu2.thisOne.name}}</a>
                  </span>
                 </li>
                 <li class="itemli" v-for="(menu3, index3) in menu2.nextList" :key="index3">
                   <span
                     v-if="
                       ($store.state.userLogin &&
                         menu3.thisOne.showType == 'member') ||
                       menu3.thisOne.showType == 'all'
                     "
                     @click="goPage(menu3.thisOne)"
                     >
                     <!-- <template v-if="menu3.thisOne.name=='视频咨询'">
                       <Poptip trigger="hover" placement="right">
                         {{ menu3.thisOne.name }}
                         <template #content>
                           <div style="text-align:center;padding:1.2rem 0">
                           <img
                             class="wxewm"
                             src="https://oss-cn-shanghai.aliyuncs.com/connectplus/origin/202301/45b38970f37e62d4c24567a04cb7431c.png"
                             style="width:12rem;height:12rem"
                           />
                             <div style="margin-top:0.5rem;font-size: 9px;color: #68696B;font-weight: 400;">微信扫码查看</div>
                           </div>
                         </template>
                       </Poptip>
                       
                     </template> -->
                     <template>
                      <a  :target="menu3.thisOne.newWindows?'_blank':'_self'" :href="menu3.thisOne.linkUrl?(hrefhost+menu3.thisOne.linkUrl):'javascript:void(0);'">{{ menu3.thisOne.name}}</a>
                     </template>
                     </span>
 
                     
                 </li>
               </div>
             </ul>
           </li>
           <div
             class="world_part"
             v-if="menu.thisOne.name=='世界'"
           >
             <div class="world_part_one" v-if="headerUrls[0]">
               <div class="world_img">
                 <img :src="headerUrls[0]" @click="goRouter('/journal')" />
               </div>
               <div class="world_title herf_tilte" @click="goRouter('/journal')">
                 {{ menuName0 }}
               </div>
             </div>
             <div class="world_part_two" v-if="headerUrls[1]">
               <div class="world_img">
                 <img
                   @click="goRouter('/collections/archive/woman')"
                   :src="headerUrls[1]"
                 />
               </div>
               <div
                 class="world_title herf_tilte"
                 @click="goRouter('/collections/archive/woman')"
               >
                 {{ menuName1 }}
               </div>
             </div>
           </div>
         </ul>
       </div>
     </div>
     <div :class="[menuShow ? 'show' : 'hide']">
       <div class="cover" v-if="menuShow"></div>
     </div>
     <transition>
       <div id="header-container-mb">
         <div class="refound" v-if="showRefound" @click="rules = true">
           {{ deliveryRule.name }}
         </div>
         <header
           :class="['header_mb', showRefound ? 'show-refound-content' : '',(headSearchModel)?'searchShow':'']"
           id="header-container-mb"
         >
           <div
             class
             :class="[
               'header',
               $route.name == 'home' || $route.name == '/' ? 'home-header' : '',
               headSearchModel?'searchShow':''
             ]"
           >
             <div class="left_content">
               <Icon type="close-round"></Icon>
               <template
                 v-if="
                   $route.name == 'home' ||
                   $route.name == '/' ||
                   $route.name == ''
                 "
               >
                 <img
                   @click="searchProduct"
                   v-if="searchModeal"
                   class="menu-icon"
                   src="../../assets/image/icon/home-menu.svg"
                 />
                 <img
                   @click="getMenu"
                   v-else-if="!menuShow"
                   class="menu-icon"
                   src="../../assets/image/icon/home-menu.svg"
                 />
                 <img
                   @click="getMenu"
                   class="menu-icon-mb"
                   v-else
                   src="../../assets/image/icon/mb-close.svg"
                 />
               </template>
               <template v-else>
                 <img
                   @click="getMenu"
                   class="menu-icon"
                   src="../../assets/image/icon/menu.svg"
                   v-if="!menuShow"
                 />
                 <img
                   @click="showMenu"
                   v-else-if="searchModeal"
                   class="menu-icon"
                   src="../../assets/image/icon/home-menu.svg"
                 />
                 <img
                   @click="getMenu"
                   class="menu-icon-mb"
                   v-else
                   src="../../assets/image/icon/mb-close.svg"
                 />
               </template>
             </div>
             <div class="center_content" @click="goRouter('/')">
               <template
                 v-if="
                   $route.name == 'home' ||
                   $route.name == '/' ||
                   $route.name == ''
                 "
               >
                 <img
                   class="logo_home"
                   src="../../assets/image/logo/tb_logo_mb.png"
                 />
               </template>
               <template v-else>
                 <img
                   class="logo"
                   v-if="!menuShow"
                   src="../../assets/image/logo/logo.svg"
                 />
                 <img
                   class="logo"
                   v-else
                   src="../../assets/image/logo/logo-mb.svg"
                 />
               </template>
             </div>
             <div class="right_content">
               <!-- 这里 -->
              
               <template
                 v-if="
                   $route.name == 'home' ||
                   $route.name == '/' ||
                   $route.name == ''
                 "
               >
               <img
                   @click="searchProduct(1)"
                   class="menu-icon-mb"
                   width="3.2rem;height:3.2rem;"
                   v-if="!menuShow"
                   src="../../assets/image/icon/mb-search.svg"
                   style="margin-right:1.2rem"
                 />
                 <img
                   @click="goRouter('/shop-cart')"
                   class="menu-icon"
                   style="width:1.6rem"
                   v-if="!menuShow"
                   src="../../assets/image/icon/home-shopping-bag.svg"
                 />
                 <img
                   @click="searchProduct()"
                   class="menu-icon-mb"
                   v-else
                   src="../../assets/image/icon/mb-search.svg"
                 />
               </template>
               <template v-else>
                 <img
                   @click="searchProduct(1)"
                   class="menu-icon-mb"
                   width="3.2rem;height:3.2rem;"
                   v-if="!menuShow"
                   src="../../assets/image/icon/mb-search-gray.svg"
                   style="margin-right:1.2rem"
                 />
                 <img
                   @click="goRouter('/shop-cart')"
                   class="menu-icon"
                   style="width:1.6rem"
                   src="../../assets/image/icon/shopping-bag.svg"
                   v-if="!menuShow"
                 />
                 <img
                   v-else-if="searchModeal"
                   @click="cancelSearchingDialog"
                   class="menu-icon-mb"
                   src="../../assets/image/icon/mb-close.svg"
                 />
 
                 <img
                   @click="searchProduct()"
                   class="menu-icon-mb"
                   v-else
                   src="../../assets/image/icon/mb-search.svg"
                 />
               </template>
             </div>
             <div class="mob" v-if="isMobScreen">
               <min-shop-bag
                 @makeShopShow="makeShopShow"
                 @showAddMember="showAddMember"
                 :showMyShopCart="showMyShopCart"
               ></min-shop-bag>
               <min-love-list
                 :showLoveList="showLoveList"
                 @makeLoveListShow="makeLoveListShow"
               ></min-love-list>
             </div>
           </div>
 
           <div class="menu_box" v-if="menuShow">
             <div
               id="firstMenu"
               :class="[
                 'menu_content tran visi',
                 $route.name == 'home' && showRefound
                   ? 'home_child_menu_content'
                   : 'part_child_menu_content',
               ]"
             >
               <ul
                 class="menu"
                 v-for="(headerItem, index) in allMenuList"
                 :key="index"
               >
                 <li
                   @click="getChildMenu(index, 'header')"
                   v-if="
                     ($store.state.userLogin &&
                       headerItem.thisOne.showType == 'member') ||
                     headerItem.thisOne.showType == 'all'
                   "
                 >
                   {{ headerItem.thisOne.name }}
                 </li>
               </ul>
               <ul class="menu_other">
                 <li @click="goRouter('/account/love-list')">
                     愿望清单 {{ lovecount == 0 ? "" : lovecount }}
                 </li>
                 <li @click="goRouter('/shop-cart')">
                   我的购物袋 {{ cartcount ? cartcount : "" }}
                 </li>
                 <li @click="goRouter('/login')" v-if="hasLogin">登录</li>
                 <li @click="goRouter('/account/user-info')" v-else>我的账户</li>
                 <li @click="goRouter('/store-list')">店铺</li>
                 <ul
                   class="fmenu"
                   v-for="(footerItem, findex) in allFooterList"
                   :key="findex"
                 >
                   <li @click="getChildMenu(findex, 'footer')">
                     {{ footerItem.thisOne.name }}
                   </li>
                 </ul>
                 <li @click="toSub">订阅电子报</li>
               </ul>
             </div>
             <div
               id="secondMenu"
               :class="[
                 'child_menu_content tran second-level-menu  visih',
                 $route.name == 'home' && showRefound
                   ? 'home_child_menu_content'
                   : 'part_child_menu_content',
               ]"
             >
               <div class="menu_tilte" @click="backFirstMenu()">
                <div class="menu_back">返回</div>
                 {{ firstMenuName }}
               </div>
               <div class="menus">
                 <ul
                   :class="[menu.thisOne.name=='世界'?'menus_itemworld':'menus_item']"
                   v-for="(menu, indexp) in menuList"
                   :key="indexp"
                 >
                   <li
                     v-for="(menu2, index2) in menu.nextList"
                     v-show="
                       ($store.state.userLogin &&
                         menu2.thisOne.showType == 'member') ||
                       menu2.thisOne.showType == 'all'
                     "
                     :key="index2"
                     :class="[
                       'menu_cc',
                       menuType == 'footer' ? 'footer_cc' : '',
                     ]"
                   >
                     <div
                       class="menu_img"
                       v-if="
                         menu.thisOne.name=='世界' && index2 == 1 && menuType == 'header'
                       "
                     >
                       <div class="world_img">
                         <img
                           :src="headerUrls[0]"
                           @click="goRouter('/journal')"
                         />
                       </div>
                     </div>
                     <div
                       class="menu_img"
                       v-if="
                         menu.thisOne.name=='世界'&& index2 == 2 && menuType == 'header'
                       "
                     >
                       <div class="world_img">
                         <img
                           :src="headerUrls[1]"
                           @click="goRouter('/collections/archive/woman')"
                         />
                       </div>
                     </div>
                     <ul class="menu_dd">
                       <div class="menu_name">
                         <li :class="indexp == 0 ? 'first_name' : 'last_name'">
                           <img
                             class="psb-icon"
                             src="../../assets/image/logo/psb-icon.png"
                             v-if="(headerFooterIndex == 2) & (index2 == 4)"
                           />
                           <span
                             :class="menuType == 'footer' ? 'footer-menu' : ''"
                             @click="goPage(menu2.thisOne)"
                             ><a :target="menu2.thisOne.newWindows?'_blank':'_self'" :href="menu2.thisOne.linkUrl?(hrefhost+menu2.thisOne.linkUrl):'javascript:void(0);'">{{ menu2.thisOne.name }}</a></span
                           >
                         </li>
                         <li
                           class
                           v-for="(menu3, index3) in menu2.nextList"
                           :key="index3"
                           v-show="(($store.state.userLogin &&menu3.thisOne.showType == 'member') ||menu3.thisOne.showType == 'all')">
                           <span @click="goPage(menu3.thisOne)">
                            <a :target="menu3.thisOne.newWindows?'_blank':'_self'" :href="menu3.thisOne.linkUrl?(hrefhost+menu3.thisOne.linkUrl):'javascript:void(0);'">{{
                             menu3.thisOne.name
                           }}</a>
                           </span>
                         </li>
                       </div>
                     </ul>
                   </li>
                 </ul>
               </div>
             </div>
           </div>
         </header>
       </div>
     </transition>
     <delivery-rules
       :rules="rules"
       :returnData="deliveryRule.content"
       v-on:close="colseRules"
     ></delivery-rules>
     <search
       :search-dialog-margin-top="searchDialogMarginTop"
       @cancelClick="cancelSearchingDialog"
       @clearSerchModal="clearSerchModal"
       :searchModeal="searchModeal"
       :headSearchModel="headSearchModel"
       v-on:close="colseRules"
     ></search>
     <SubPop></SubPop>
 
     <add-member-pop
       :showAdd.sync="showAdd"
       :showAddText="showAddText"
       v-on:close="colseMember"
     ></add-member-pop>
   </div>
   </div>
 </template>
 
 <script>
 import { checkLinkUrl, setHeaderTop } from "../../utils/utils";
 import { setTimeout } from "timers";
 import DeliveryRules from "./DeliveryRulesPop";
 import MinShopBag from "./MinShopBag";
 import MinLoveList from "./MinLoveList";
 import Account from "../Account";
 import Search from "./SearchPop";
 import SubPop from "../common/SubPop";
 import addMemberPop from "../common/AddMemberPop";
 export default {
   name: "Header",
   inject: ["reload"],
   metaInfo() {
       return {
         meta: this.metaData
       }
 
     },
   data() {
     var _this = this;
     return {
       showAddText: false,
       showAdd: false,
       isnstoreregistration:false,
       isnstorePage:false,
       deliveryRule: {
         id: "",
         show: false,
         type: "",
         name: "",
         content: "",
       },
       hasLogin: window.localStorage.getItem("token"),
       firstMenuName: "",
       screenWidth: document.body.clientWidth,
       isMobScreen: false,
       hoverMenu: false,
       showLoveList: false,
       showMyAccount: false,
       showMyShopCart: false,
       searchModeal: false,
       hrefhost:window.location.protocol+'//'+window.location.host,
       headSearchModel:false,//手机端导航上的搜索框
       rules: false,
       menuType: "header",
       showMenuType: 0,
       currentPath:'',
       MainIndex:0,
       mainRefLeft:0,
       mouserhover: false,
       showMenuList: false,
       menuShow: false,
       showChildMenu: false,
       chooseChildMenu: false,
       allFooterList: [],
       menuName0: "日志",
       menuName1: "时装秀",
       menuListNext: [],
       firstHoverName: "",
       headerUrls: [],
       menuList: [],
       allMenuList: [],
       headerFooterIndex: null,
       searchDialogMarginTop: 0,
       ossSuffix: "?x-oss-process=style/tb_header_w_200",
       ossSuffixOrigin: "?x-oss-process=style/tb_header_w_200_origin",
       metaData: [{
           name: 'viewport',
           content: 'width=device-width, initial-scale=1.0, user-scalable=no,minimum-scale=1.0, maximum-scale=1.0'
         }]
     };
   },
   components: {
     DeliveryRules,
     Search,
     MinShopBag,
     Account,
     MinLoveList,
     SubPop,
     addMemberPop,
     isnstoreregistrationtype:null,
   },
   computed: {
     showRefound() {
       this.deliveryRule = this.$store.state.showRefound;
       return this.$store.state.showRefound.show;
     },
     cartcount() {
       return this.$store.state.cartCount;
     },
   
     lovecount() {
       return this.$store.state.lovecount;
     },
     isShow() {
       let _path = this.$route.path;
       let flag = true;
       if (_path == "/checkout"||_path.indexOf('instore-registration')>-1||_path.indexOf('h5tomp')>-1) {
         flag = false;
       } else {
         flag = true;
       }
       return flag;
     },
     isExitlogin() {
       return this.$store.state.isExitlogin;
     },
     getShowAdd(e) {
       return this.$store.state.getShowAdd;
     },
   },
   watch: {
     "$route.path": function (newVal, oldVal) {
       var that = this;
    
       this.isnstoreregistration=false;
       if(newVal.indexOf("/account") > -1){
         this.$utils.setSeoInfo({},this);
       }
      
       if(newVal.indexOf('/20th-anniversary')>-1){
        
         this.currentPath='th20'
        
       }else{
        this.currentPath=''
       }
       if(newVal=='/instore-registration/customer-form'||newVal=='/instore-registration/submit-success'){
         this.isnstoreregistration=true
         if(newVal=='/instore-registration/customer-form'){
           this.isnstoreregistrationtype=1;
         }else{
           this.isnstoreregistrationtype=2;
         };
       }
       if(newVal.indexOf("/instore-registration")>-1){
         this.isnstorePage=true;
           this.metaData = [{
             name: 'viewport',
             content: 'user-scalable=no,width=1180'
           }]
       } else{
         this.metaData = [{
             name: 'viewport',
             content: 'width=device-width, initial-scale=1.0, user-scalable=no,minimum-scale=1.0, maximum-scale=1.0'
          }]
         this.isnstorePage=false;
         that.initCrmKfUser();
       }
       that.getLoginStatus();
 
       
     },
     '$store.state.userLogin':function (newVal, oldVal) {
       this.getHeadAndFoot()
     },
     getShowAdd: {
       deep: true,
       handler: function (val, oldVal) {
         this.showAdd = val;
       },
     },
     isExitlogin(curVal, oldVal) {
       // 监听登陆状态
       this.hasLogin = window.localStorage.getItem("token") ? false : true;
     },
     screenWidth: {
       handler: function (val, oldVal) {
         if (val <= 768) {
           this.isMobScreen = true;
         }
       },
       immediate: true,
     },
   },
   mounted() {
     const that = this;
    
     window.onresize = () => { 
       return (() => {
         window.screenWidth = document.body.clientWidth;
         that.screenWidth = window.screenWidth;
         that.$store.commit("setValue", ["screenWidth",  window.screenWidth]);
       })();
     };
   },
   created() {
     var that = this;
  
     setTimeout(()=>{
       // that.initCrmKfUser();
       that.getLoginStatus();
       that.getHeadAndFoot(); 
     },500);
   
       // this.$nextTick(() => {
         
       //   if(!that.isnstorePage){
           
             
       //   }
       // })
   
   },
   methods: {
     initCrmKfUser() {
   
       if (this.$store.state.userId != "" && this.$store.state.userId != null) {
         // console.log(this.$store.state.userId,'99')
         ysf("config", {
           uid: this.$store.state.userId,
         });
       }
       if (ysf) {
         let data = [
           {
             index: 0,
             key: "referrer",
             label: "referrer",
             value: window.location.href,
             href: window.location.href,
           },
         ];
         ysf("config", {
           uid: this.$store.state.userId,
           name: this.$store.state.name,
           data: JSON.stringify(data),
         });
       }
     },
     clearSerchModal(e){
 
       this.headSearchModel=false;
       this.SearchModel=false;
   
     },
     colseMember() {
       this.showAdd = false;
       this.$store.commit("setValue", ["getShowAdd", false]);
     },
     // goisnstore(type){
     //   if(type ==1){
     //     this.$router.push(`/instore-registration/select-store`);
     //   }else{
     //     this.$router.go(-1)
     //   }
       
     // },
     showAddMember(e) {
       this.showAdd = e;
     },
     makeLoveListShow(e) {
       this.showLoveList = e;
       setTimeout(() => {
         this.showLoveList = false;
       }, 3000);
     },
     makeShopShow(e) {
       this.showMyShopCart = e;
       setTimeout(() => {
         this.showMyShopCart = false;
       }, 3000);
     },
     getLoginStatus() {
       const that = this;
       this.hasLogin = window.localStorage.getItem("token") ? false : true;
     },
     userExit() {
       this.hasLogin = true;
       this.showMyAccount = false;
       window.localStorage.removeItem("userInfo");
       window.localStorage.removeItem("token");
       let isExitlogin = !this.$store.state.isExitlogin;
       this.$store.commit("UpdateLoginStatus", isExitlogin);
       this.$store.commit("upDateLoveCount", 0);
       this.$store.commit("upDateShopCount", 0);
       this.$store.commit("setValue", ["userLogin", false]);
       // this.$store.commit("setValue", ["userLogin", true]);
       this.$router.push({ name: "home" });
     },
 
     getRecommendSearchingList() {},
 
     getHeadAndFoot() {
       var that = this;
       let headerUrls=[];
       let url = this.$store.state.API.plp.getHeadAndFoot;
       let paramsObj = {
         merchantId: this.$store.state.storeId,
         source: "PC",
       };
       this.$http.get(url + "?" + that.$qs.stringify(paramsObj)).then((res) => {
         if (res.status == 200) {
           if (res.data.returnData.headDetails) {
              // 这里去掉隐藏的和会员私享的
             let  HeadList=res.data.returnData.headDetails.details;
             let  NewHeadList=[];
             HeadList.forEach((item,index)=>{
               if((this.$store.state.userLogin&&item.thisOne.showType=='member')||item.thisOne.showType=='all'){
                 NewHeadList.push(item)
               }
             })
         
 
             this.allMenuList = NewHeadList;
             console.log(this.allMenuList,'this.allMenuList')
             for(let i=0;i<this.allMenuList.length;i++){
               if(this.allMenuList[i].thisOne.name=='世界'){
                for(let k=0;k<this.allMenuList[i].nextList.length;k++){
                  if(this.allMenuList[i].nextList[k].thisOne.name=='日志'){
                    headerUrls.push(this.allMenuList[i].nextList[k].thisOne.picUrl)
                  }
                  if(this.allMenuList[i].nextList[k].thisOne.name=='时装秀'){
                    headerUrls.push(this.allMenuList[i].nextList[k].thisOne.picUrl)
                  }
                    console.log(this.allMenuList[i].nextList[k],'世界')
                }
               }
               for(let j=0;j<this.allMenuList[i].nextList.length;j++){
                  this.allMenuList[i].max=0;
                  for(let k=0;k<this.allMenuList[i].nextList.length;k++){
                    if(this.allMenuList[i].nextList[k].nextList.length>=this.allMenuList[i].max){
                      this.allMenuList[i].max=this.allMenuList[i].nextList[k].nextList.length+1
                    }
                  }
                  // console.log(this.allMenuList[i].nextList,'allMenuList1')
               }
             };
            //进行补齐
            for(let i=0;i<this.allMenuList.length;i++){
              for(let j=0;j<this.allMenuList[i].nextList.length;j++){
                if(this.allMenuList[i].nextList[j].nextList.length<=this.allMenuList[i].max){
                  this.allMenuList[i].nextList[j].nextList=this.allMenuList[i].nextList[j].nextList.concat(this.Completearray(this.allMenuList[i].max-this.allMenuList[i].nextList[j].nextList.length))
                }
                console.log(this.allMenuList[i].nextList[j].nextList.length,'allMenuList1')
              }
            }


             console.log(this.allMenuList,'allMenuList')
             this.allFooterList = res.data.returnData.footDetails.details;
             this.$store.commit("setValue", ["footerList", this.allFooterList]);
           }
           let localurls=['https://oss-cn-shanghai.aliyuncs.com/connectplus/origin/202311/ec9fb7adebc3a40d5b3712dbb5d7d444.png','https://oss-cn-shanghai.aliyuncs.com/connectplus/origin/202307/466efbbbb5ee6a5c688f22d4e73b9db6.jpeg']
           this.headerUrls =headerUrls||localurls;
           // for(let i=0;i< this.headerUrls.length;i++){
           //   this.headerUrls[i] = this.$utils.replaceImage(this.headerUrls[i]);
           // }
 
           // this.loadImages(0);
         } else {
         }
       });
     },
     loadImages(i) {
       // console.log("loadImages: ",i);
       var that = this;
       var img = new Image();
 
       img.onload = function () {
         //检测是否支持webp格式 
         let imgsec = that.headerUrls[i];
         let flag = that.$utils.checkIsUpdatetoWebp(this, imgsec);
         if (flag) {
           var imageList = that.headerUrls[i] + that.ossSuffix;
           that.$set(that.headerUrls, i, imageList);
         } else {
           var imageList = that.headerUrls[i] + that.ossSuffixOrigin;
           that.$set(that.headerUrls, i, imageList);
         }
         let count = i + 1;
         if (count < that.headerUrls.length) {
           that.loadImages(count);
         }
       };
       img.onerror = function () {
         let count = i + 1;
         if (count < that.headerUrls.length) {
           that.loadImages(count);
         }
       };
       if (that.headerUrls[i]) {
         let flag = that.$utils.checkIsUpdatetoWebp(this, that.headerUrls[i]);
         if (flag) {
           img.src = that.headerUrls[i] + this.ossSuffix;
         } else {
           img.src = that.headerUrls[i] + this.ossSuffixOrigin;
         }
       }
     },
     backFirstMenu() {
       $("#firstMenu").removeClass("visih");
       $("#firstMenu").addClass("visi");
       $("#firstMenu").removeClass("second-level-menu");
 
       $("#secondMenu").removeClass("second-level-menu-back");
       $("#secondMenu").addClass("second-level-menu");
       setTimeout(() => {
         $("#secondMenu").addClass("visih");
       }, 100);
     },
     getChildMenu(index, type) {
       this.menuType = type;
       this.menuList = this.allMenuList.slice(index, index + 1);
       if (type == "footer") {
         this.headerFooterIndex = index; //手机页脚导航
         this.menuList = this.allFooterList.slice(index, index + 1);
       } else {
         this.menuList = this.allMenuList.slice(index, index + 1);
         console.log(this.menuList,'this.menuList')
       }
       this.firstMenuName = this.menuList[0].thisOne.name;
 
       if (this.menuList[0].nextList.length <= 0) {
         //没有子菜单时
         this.goPage(this.menuList[0].thisOne);
         return;
       }
 
       this.showMenuList = !this.showMenuList;
       this.showMenuType = index;
 
       if ($("#firstMenu").hasClass("visi")) {
         $("#firstMenu").addClass("second-level-menu");
         setTimeout(() => {
           $("#firstMenu").removeClass("visi");
           $("#firstMenu").addClass("visih");
         }, 400);
       }
 
       if ($("#secondMenu").hasClass("visih")) {
         $("#secondMenu").removeClass("second-level-menu");
         $("#secondMenu").addClass("second-level-menu-back");
         $("#secondMenu").removeClass("visih");
       }
     },
     onMouseOvershowLoveList() {
       this.showLoveList = true;
     },
 
     onMouseLeaveshowLoveList() {
       this.showLoveList = false;
     },
     onMouseOvershowMyAccount() {
       this.showMyAccount = true;
     },
     onMouseLeaveshowMyAccount() {
       this.showMyAccount = false;
     },
     onMouseOvershowShopCart() {
       this.showMyShopCart = true;
     },
     onMouseLeaveshowShopCart() {
       this.showMyShopCart = false;
     },
 
     goRouter(_r) {
       document.body.removeAttribute("class");
       this.menuShow = false;
       if (_r == "/account/love-list" || _r == "/shop-cart") {
         if (!window.localStorage.getItem("token")) {
          this.$store.commit("setValue", ["showLoginPop", true]);
           return;
         }
       }
       this.$router.push({ path: _r });
     },
     cancelSearchingDialog() {
       this.searchModeal = false;
       this.menuShow = false;
       document.getElementsByTagName("body")[0].className = "";
     },
     searchProduct(type) {
       
       if(type==1){
         this.headSearchModel=!this.headSearchModel 
         if(this.headSearchModel){
           this.searchDialogMarginTop =
           this.$refs.header_container_ref.offsetHeight;
         if (this.showRefound) {
           this.searchDialogMarginTop += 35;
         }
         }
         if (this.headSearchModel) {
         $("#firstMenu").addClass("visih");
         $("#firstMenu").removeClass("visi");
         if ($("#firstMenu").hasClass("second-level-menu")) {
           $("#firstMenu").addClass("visi");
           $("#firstMenu").removeClass("visih");
           $("#secondMenu").addClass("visih");
           $("#secondMenu").removeClass("visi");
         }
       } else {
         $("#firstMenu").addClass("visi");
         $("#firstMenu").removeClass("visih");
         if ($("#firstMenu").hasClass("second-level-menu")) {
           $("#secondMenu").addClass("visi");
           $("#secondMenu").removeClass("visih");
         }
       }
       if (this.headSearchModel || this.menuShow) {
         document.getElementsByTagName("body")[0].className = "noscroll";
       } else {
         document.getElementsByTagName("body")[0].className = "";
       }
         
         return;
        
       }
       this.searchModeal = !this.searchModeal;
      
       if (this.searchModeal) {
         this.searchDialogMarginTop =
           this.$refs.header_container_ref.offsetHeight;
         if (this.showRefound) {
           this.searchDialogMarginTop += 35;
         }
       }
       if (this.searchModeal) {
         $("#firstMenu").addClass("visih");
         $("#firstMenu").removeClass("visi");
         if ($("#firstMenu").hasClass("second-level-menu")) {
           $("#firstMenu").addClass("visi");
           $("#firstMenu").removeClass("visih");
           $("#secondMenu").addClass("visih");
           $("#secondMenu").removeClass("visi");
         }
       } else {
         $("#firstMenu").addClass("visi");
         $("#firstMenu").removeClass("visih");
         if ($("#firstMenu").hasClass("second-level-menu")) {
           $("#secondMenu").addClass("visi");
           $("#secondMenu").removeClass("visih");
         }
       }
       if (this.searchModeal || this.menuShow) {
         document.getElementsByTagName("body")[0].className = "noscroll";
       } else {
         document.getElementsByTagName("body")[0].className = "";
       }
     },
     colseRules() {
       document.body.removeAttribute("class");
       this.searchModeal = false;
       this.rules = false;
     },
     getMenu() {
       this.menuShow = !this.menuShow;
       this.searchModeal=false;
       this.headSearchModel=false;
       if (this.menuShow) {
         document.getElementsByTagName("body")[0].className = "noscroll";
       } else {
         document.getElementsByTagName("body")[0].className = "";
       }
     },
     showMenu() {
       this.searchModeal = false;
       this.menuShow = true;
       $("#firstMenu").addClass("visi");
       $("#firstMenu").removeClass("visih");
       if ($("#firstMenu").hasClass("second-level-menu")) {
         $("#secondMenu").addClass("visi");
         $("#secondMenu").removeClass("visih");
       }
     },
     mouseOverMenu(index,type) {
      
       // if (this.searchModeal) return false;
       this.MainIndex=index;
       this.mouserhover = true;
       this.menuList = this.allMenuList.slice(index, index + 1);
       this.menuListNext = this.menuList[0].nextList;

       this.firstHoverName = this.menuList[0].thisOne.name;
       this.firstMenuName = this.menuList[0].thisOne.name;
      //  let temp={
      //   nextList:[],
      //   thisOne:{
      //     name:'',
      //     id:''
      //   }
      //  }
       if(type==1){
        //  let menuList=this.menuList;
        //  let menuListNext=menuList[0].nextList;
        //  let max=0;
        //  for(let i=0;i<menuListNext.length;i++){
        //    if(menuListNext[i].nextList.length>max){
        //      max=menuListNext[i].nextList.length
        //    }
        //  }; 
        //  max=max+1;
        //  console.log(menuList,'menuList')
        //  //进行补齐
        //  for(let i=0;i<menuList[0].nextList.length;i++){
        //     if(menuList[0].nextList[i].length!=max){
        //       menuList[0].nextList[i].nextList=menuList[0].nextList[i].nextList.concat(this.Completearray(max-menuList[0].nextList[i].nextList.length))
        //     }
        //  };
        //  this.menuList=menuList;
        //  console.log(menuList,'menuList')
         this.mainRefLeft=this.$refs.mainmenu[index].offsetLeft
        
       }
       console.log(this.mainRefLeft)
       if (this.menuList[0].nextList.length > 0) {
         //没有子菜单
         this.showMenuList = true;
         this.showMenuType = index;
       } else {
         this.showMenuList = false;
       }
     },
     Completearray(num){
       let newArr=[];
       for(let i=0;i<num;i++){
        newArr.push({
          nextList:[],
          thisOne:{
            name:'',
            id:''
          }
        })

       };
      
       return newArr
      
     },
     mouseLeaveMenu(type) {
       
       if (type == "1") {
         this.mouserhover = false;
         setTimeout(() => {
           if (this.mouserhover) {
             return;
           }
           this.showMenuList = false;
           this.firstHoverName = "";
         }, 150);
       } else {
         this.showMenuList = false;
         this.firstHoverName = "";
       }
     },
     getDetailMenu(index) {
       var that = this;
       this.menuList = this.allMenuList.slice(index, index + 1);
       if (this.menuList[0].nextList.length <= 0) {
         //没有子菜单
         this.showMenuList = false;
       } else {
         this.showMenuList = !this.showMenuList;
         this.showMenuType = index;
       }
       let params = {
         link: this.menuList[0].thisOne.linkUrl,
         newWindows: this.menuList[0].thisOne.newWindows,
       };
       //checkLinkUrl(function (data) {}, params, that);
     },
     goPage(item) {
       if (item.name == "微信") {
         this.goRouter("/weChatMoblie");
       } else {
         document.body.removeAttribute("class");
         this.menuShow = false;
         var that = this;
         // if (item.linkUrl) {
         let params = {
           link: item.linkUrl,
           newWindows: item.newWindows,
         };
        // checkLinkUrl(function (data) {}, params, that);
        //  this.showMenuList = false;
       }
     },
     toSub() {
       if (!window.localStorage.getItem("token")) {
         this.$store.commit("setValue", ["showLoginPop", true]);
       } else {
         this.$store.commit("setValue", ["showSubPop", true]);
       }
     },
     getCartCount(e) {
       // this.cartcount = e;
     },
     // }
   },
 };
 </script>
 
 <style scoped lang="less">
 .isnstoreback{
  position: relative;
  top: 3.3rem;
  width: 1125px;
  margin:0 auto;
  font-weight: 400;
  color: #8E8F8B;
  font-size:12px;
  cursor: pointer;
  text-align:left
 }
 #main {
   // padding-top: 100px;
   padding-top: 10rem;
   // min-height: calc(100vh - 10rem);
 }
 .main {
   position: fixed;
   z-index: 99;
   top: 0px;
   width: 100%;
   &.th20{
    .header{
      background: #BFC1C3;
    }
    .menus{
      background:#BFC1C3!important;
    }
   }
   .refound {
     position: fixed;
     top: 0;
     width: 100%;
     height: 3.5rem;
     z-index: 40;
     height: 3.5rem;
     padding: 1rem 0;
     background-color: rgb(74, 74, 74);
     font-size: 1.2rem;
     color: #ffffff;
     text-decoration: underline;
     cursor: pointer;
     text-align: center;
     transition: height 0.3s;
   }
 
   .header_pc {
     display: block;
     &.show-refound-content {
       margin-top: 3.5rem;
     }
 
     &.search {
       &::before {
         content: "";
         position: fixed;
         top: 0;
         right: 0;
         left: 0;
         height: 6.6rem;
         z-index: 100;
       }
     }
     &.maxsearch {
       &::before {
         content: "";
         position: fixed;
         top: 0;
         right: 0;
         left: 0;
         height: 10rem;
         z-index: 100;
       }
     }
   }
   .header_mb {
     display: none;
   }
   #header-container-mb {
     .refound {
       display: none;
     }
   }
   .psb-icon {
     width: 1.2rem;
     height: 1.2rem;
     vertical-align: middle;
   }
   .header {
     width: 100%;
     margin: 0 auto;
     height: 6.6rem;
     padding: 0 4.2rem;
     display: flex;
     justify-content: space-between;
     align-items: center;
     font-family: ArialNarrow, sans-serif;
     background: white;
 
     .left_content {
       display: flex;
       flex: 1 0;
       align-items: center;
       align-content: center;
 
       ul {
         display: flex;
         list-style: none;
         li {
           padding: 0.5rem 0.8rem;
           cursor: pointer;
           .line {
             text-decoration: underline;
           }
         }
       }
     }
     .logo {
       width: 10.8rem;
       height: 4.5rem;
       cursor: pointer;
     }
     .right_content {
       display: flex;
       flex: 1 0;
       align-items: center;
       align-content: center;
       justify-content: flex-end;
       .right_item {
         padding: 0.5rem 0.8rem;
         border: 0.1rem solid transparent;
         cursor: pointer;
         &.min-shop-bag {
           position: relative;
           // border: 0.1rem solid transparent;
           // transition: border 0.3s ease;
         }
         &.search-item {
           z-index: 10000;
           padding-right: 2.9rem;
         }
         &.active-bag {
           // padding: 0.5rem 0.8rem;
           font-size: 1.2rem;
           border: 0.1rem solid #e7e7e7;
           border-bottom-color: transparent;
           background-color: #fff;
           position: relative;
           z-index: 52;
         }
         .search-icon {
           width: 1.5rem;
           height: 1.5rem;
           margin-top: 0.2rem;
           &.active-search {
             border-bottom: 1px solid;
           }
         }
         &:last-child {
           // padding-right: 0;
         }
         &:hover {
           text-decoration: underline;
         }
         /deep/ .ivu-icon-ios-search {
           font-size: 1.5rem;
           font-weight: bold;
           padding: 0 0.8rem;
         }
       }
     }
   }
   .header_menu_pc {
     position: absolute;
     top: 100%;
     right: 0;
     left: 0;
     display: flex;
     justify-content: center;
     opacity: 0;
     pointer-events: none;
     visibility: visible;
     opacity: 1;
     cursor: pointer;
     &.showMenu {
       visibility: visible;
       opacity: 1;
     }
     &.hideMenu {
      visibility: hidden;
    

     }
     .menus {
     
       // min-width: calc(100% - 39rem);
       width: 100%;
      //  min-height: 36rem;
       flex-direction: row;
       pointer-events: auto;
       background-color: #fff;
       font-family: ArialNarrow, sans-serif;
       border-top: 0.1rem solid #e7e7e7;

 
       .menus_item {
         display: flex;
         flex: 1 0 auto;
         flex-flow: row nowrap;
         // justify-content: space-between;
         align-content: flex-start;
         padding: 0 5rem;
         text-align: left;
         height: 100%;
         
         .mainLi{
          width: 100%;
          max-width: 28.8rem;
          border-right: 0.1rem solid #e7e7e7;
          &:nth-last-child(1){
            max-width: 100%;
            border-right:0
          }
          &:nth-last-of-type(1){
            border-right:none;
            max-width:100%;
          }
          &.mainLi2 .itemli, &.mainLi2  .menu_cc{
            padding-left: 3.1rem;
            box-sizing:border-box;
          }
         }
         li{
           // margin-right:2rem;
         }
         .menu_dd {
           display: flex;
           .menu_name{
            width: 100%;
           }
           .itemli{
            width: 100%;
            margin-bottom: 0;
            padding: 0;
            border-bottom: 0.1rem solid #e7e7e7;
            line-height: 2.33;
            height: 3rem;
            box-sizing: border-box;
            &:nth-last-of-type(1){
              // border-bottom: 0;
            }
         }
         }
         .menu_dd li:nth-of-type(1) {
           text-decoration: underline;
           padding-top: 4rem;
           border-bottom: 0.1rem solid #e7e7e7;
           line-height: 2.33;

         }
         .world_part {
           display: flex;
           margin-left: 6rem;
           align-items: center;
           padding-right:3rem;
           cursor: pointer;
         
           .world_part_one {
             padding-right: 3rem;
             margin: 0 3rem 0 0;
             // height: 24rem;
             filter: grayscale(100%);
             &:hover {
               filter: initial;
             }
           }
           .world_img {
             width:21rem;
            //  margin-top:4rem;
       
             img{
               width:21rem;
             
               object-fit:cover
             }
             filter: grayscale(100%);
             &:hover {
               filter: initial;
             }
           }
           .world_title {
             text-align: left;
             padding-top: 1rem;
             text-decoration: underline;
           }
         }
 
         ul li {
          
           :hover {
             text-decoration: underline;
           }
         }
       }
     }
   }
   .my-container {
     padding: 0;
     position: absolute;
     top: calc(100% - 0.1rem);
     width: 16rem;
     max-width: 16rem;
     position: absolute;
     right: 0;
     background: white;
     /deep/ .nav-content {
       display: none;
     }
     /deep/.nav .user-nav {
       margin-right: 0rem;
       font-size: 1.2rem;
       .user-name {
         display: block;
       }
       .exit {
         margin-top: 0;
       }
     }
   }
 }
 @media screen and (max-width: 1440px) {
   .main .header_menu_pc .menus {
     // min-width: calc(100% - 20rem);
   }
 }
 @media screen and (max-width: 1293px) {
   .main .header_menu_pc .menus {
     // min-width: calc(100% - 10rem);
     .menus_item.word{
       .mainLi{
        .itemli{
          width: 208px;
          width: 100%;
        }
       }
       .world_part{
        .world_part_one{
          margin-right: 1rem;
          padding-right: 0;
          height: 80%;
        }
        .world_part_two{
          height: 80%;
        }
        .world_img{
          width: 10rem;
          height: 100%;
          img{
            height: 100%;
            width: 10rem;
            object-fit: cover;
          }
        }
       }
     }
   }
 }
 @media screen and (max-width: 1024px) {
   .main .header {
     padding: 0 2.2rem;
   }
 }
 @media screen and (max-width: 992px) {
   .main .header_menu_pc .menus {
     min-width: 100%;
   }
 }
 @media screen and (max-width: 1080px){
  .isnstoreback{
   left:4.5%;
   font-size: 24px;
  }
 }
 @media screen and (max-width: 768px) {
   .main {
     .header_pc {
       display: none;
     }
     .header_mb {
       display: block;
       &.show-refound-content {
         margin-top: 3.5rem;
       }
     }
     .header_menu_pc {
       display: none;
     }
     #header-container {
       .refound {
         display: none;
       }
     }
     #header-container-mb {
       .refound {
         display: block;
       }
     }
     .header {
       padding: 0 2rem;
       height: 5rem;
       &.searchShow{
         background:rgba(0,0,0,.75)!important;
       }
      
       &.home-header {
         background: transparent;
         height: 11rem;
       }
       .left_content,
       .center_content,
       .right_content {
         position: relative;
       }
       .logo {
         width: 5.7rem;
         height: 2.4rem;
       }
       .logo_home {
          width: 12rem;
          position: relative;
          top: 1rem;
       }
       .menu-icon {
         width: 2rem;
         cursor: pointer;
 
         &.show-icon {
           color: white;
         }
       }
       .menu-icon-mb {
         width: 2.6rem;
       }
     }
     .menus{
      display: flex; 
      flex-direction: column;
      .menus_itemworld{
          width: 100%;
          .menu_cc{
            display: flex!important;
            width: 100%!important;

          }
         }
      .menus_item{
        width: 100%;
        column-span: none;
        columns: 12rem;
        
      }
     }
     .menu_box {
       font-family: ArialNarrow, sans-serif;
 
       a {
         color: white;
       }
       .menu_content {
         position: fixed;
         opacity: 1;
         // transition: opacity 0.5s ease-in-out;
         right: 2rem;
         left: 2rem;
         width: calc(100% - 4rem);
         text-align: left;
         color: #ffffff;
         overflow-y: auto;
         height: 100%;
         &.second-level-menu-back {
           transform: translateX(100%);
           -ms-transform: translateX(100%); /* IE 9 */
           -moz-transform: translateX(100%); /* Firefox */
           -webkit-transform: translateX(100%); /* Safari 和 Chrome */
           -o-transform: translateX(100%); /* Opera */
         }
         &.second-level-menu {
           transform: translateX(-100%);
           -ms-transform: translateX(-100%); /* IE 9 */
           -moz-transform: translateX(-100%); /* Firefox */
           -webkit-transform: translateX(-100%); /* Safari 和 Chrome */
           -o-transform: translateX(-100%); /* Opera */
         }
 
         ul li {
           padding: 0.7rem 0;
           line-height: initial;
         }
         .menu {
           font-size: 1.6rem;
           line-height: initial;
           font-weight: 500;
           text-align: center;
         }
         .menu_other {
           margin-top: 4rem;
           font-size: 1.2rem;
           text-align: center;
         }
       }
       .visi {
         visibility: visible;
       }
       .visih {
         visibility: hidden;
       }
       .tran {
         transition: transform 0.4s;
       }
       .home_child_menu_content {
         padding-bottom: 15rem;
       }
       .part_child_menu_content {
         padding-bottom: 10rem;
       }
       .child_menu_content {
         position: fixed;
         opacity: 1;
         // padding: 0 2rem;
         left: 2rem;
         right: 2rem;
         width: calc(100% - 4rem);
         height: 100%;
         overflow-y: auto;
         // padding-bottom: 6rem;
         text-align: left;
         color: #ffffff;
 
         &.second-level-menu-back {
           transform: translateX(0%);
           -ms-transform: translateX(0%); /* IE 9 */
           -moz-transform: translateX(0%); /* Firefox */
           -webkit-transform: translateX(0%); /* Safari 和 Chrome */
           -o-transform: translateX(0%); /* Opera */
         }
         &.second-level-menu {
           transform: translateX(100%);
           -ms-transform: translateX(100%); /* IE 9 */
           -moz-transform: translateX(100%); /* Firefox */
           -webkit-transform: translateX(100%); /* Safari 和 Chrome */
           -o-transform: translateX(100%); /* Opera */
         }
 
         .menu_tilte {
           position: relative;
           width: 100%;
           // margin-bottom: 0.4rem;
           padding: 0.8rem 0;
           text-align: center;
           font-size: 1.6rem;
           .menu_back{
            position: absolute;
            left: 1.8rem;
            font-size: 1.1rem;
            top: 34%;
           }
           &::after {
             content: "<";
             position: absolute;
             top: 29%;
             left: 0;
             color: #5c5d5f;
             transform: translateY(0%);
             font-size:1.3rem;
           }
         }
         .menu_cc {
           display: flex;
           margin: 1.4rem 2rem 0 0;
           padding-bottom: 2rem;
           display: inline-block;
           width: 100%;
          
          
           &.footer_cc {
             margin: 0rem 2rem 0 0;
             .menu_dd {
               width: 100%;
             }
           }
           .menu_img {
             width: 45%;
             // margin-bottom: 2rem;
             margin-right: 2rem;
           }
           .menu_dd {
            //  width: 55%;
             .menu_name {
               li {
                 padding: 0.8rem 0;
                 a{
                 
                  &:hover{
                    color: #646464!important;
                    text-decoration: underline;
                    cursor: pointer;
                  }
                 }
               }
               .menu_cc {
                 cursor: pointer;
               
               }
               .first_name {
                 color: #8e8f8b;
                 padding: 0.8rem 0 0.8rem;
                 a{
                  color: #8e8f8b;
                  &:hover{
                    color: #646464!important;
                    text-decoration: underline;
                    cursor: pointer;
                  }
                 }
                 .footer-menu {
                   color: white;
                 }
               }
               .last_name {
                 padding: 0 0.8rem;
               }
 
               a {
                 font-family: ArialNarrow, sans-serif;
               }
             }
           }
         }
        
       }
     }
     .cover {
       position: fixed;
       top: 0;
       right: 0;
       bottom: 0;
       left: 0;
       opacity: 0.75;
       background-color: #000;
       transition: opacity 0.5s ease-in-out;
     }
   }
   /deep/.slick-arrow {
     display: none;
   }
 }
 .v-enter,
 .v-leave-to {
   opacity: 0;
   transform: translateX(150px);
 }
 
 /* v-enter-active 【入场动画的时间段】 */
 /* v-leave-active 【离场动画的时间段】 */
 .v-enter-active,
 .v-leave-active {
   transition: all 0.8s ease;
 }
 </style>
 <style>
 .mob .min-bag-container {
   width: 100% !important;
   top: 5rem !important;
   max-width: 100% !important;
 }
 
 </style>
 
 


// WEBPACK FOOTER //
// src/components/common/Header.vue